import React from 'react';
import CardPlaceHolder from './card_placeholder';
import {connect} from 'react-redux';
import SeoPage from '../SeoPage/seoPage';
import InfiniteScrollVenueList from './infiniteScroll';



class VenueList extends React.Component{
  constructor(props) {
     super(props);
   }

   componentDidMount(){
     window.scrollTo(0,0);
   }


    render(){
      var info = {title : "List of offers coupons - playo" ,
        description: "List of all the offers coupons - playo"};

      return (

       <div className="container background-light list-min-height">

         <SeoPage info={info}/>

           <InfiniteScrollVenueList/>

          {this.props.shimmer ?<CardPlaceHolder/> : <span/> }

          </div>
      );
    }

}

function mapStateToProps(state) {
  return {
    venueData : state.VenueList,
    shimmer   : state.Shimmer,
    loader    : state.Loader,
    location  : state.Location
  };
}

export default connect(mapStateToProps)(VenueList);



// WEBPACK FOOTER //
// ./src/components/Offers/offer-list.js